@if (adaptedArticles.length > 0) {
  @for (article of adaptedArticles; track article.id) {
    <div class="group" [routerLink]="['/articles', article.id]">
      <!-- First column on desktop. on mobile this is hidden -->
      @if (embedContext() !== 'magazineEditionOverview') {
        <div class="column-type-authors article-authors">
          <div>
            @if (embedContext() !== 'selectieAndEssentie') {
              <!-- Article type -->
              <dhp-article-type-badge [article]="article" />
            }
            <!-- Article authors on all contexts, except author details where it would just repeat the current page's author -->
            @if (embedContext() !== 'authorDetails') {
              <dhp-article-meta-data
                [article]="article"
                [isSelectionAndEssence]="
                  embedContext() === 'selectieAndEssentie'
                "
              />
            }
          </div>
        </div>
      }
      <!-- Second column on desktop. full width on mobile -->
      <div class="column-main">
        <div class="subcolumn-main">
          <!-- Title, subtitle and magazine info -->
          <div
            class="flex flex-col items-start justify-start gap-4 self-stretch"
          >
            @if (article.categories?.length) {
              <!-- Article categories -->
              <dhp-article-category-list
                [article]="article"
                (categoryArticle)="onArticleCategoryClick($event)"
              />
            }
            <!-- Article authors: only needed here for magazineEditionOverview, which has no left column -->
            @if (embedContext() === 'magazineEditionOverview') {
              <div class="article-authors">
                <!-- Article type -->
                <dhp-article-type-badge [article]="article" />
                <dhp-article-meta-data
                  [article]="article"
                  [isSelectionAndEssence]="
                    embedContext() === 'selectieAndEssentie'
                  "
                />
              </div>
            }
            <div
              class="article-title"
              [attr.lang]="article.magazine?.language ?? 'nl'"
            >
              {{ article.title | truncateClean }}
            </div>
          </div>
          <!-- gap 4 -->
          <div
            class="article-description"
            [attr.lang]="article.magazine?.language ?? 'nl'"
          >
            {{ article.content_preview | truncateClean }}
          </div>
        </div>
        <!-- The left cell but then only in the mobile view, below the title -->
        <div class="subcolumn-type-authors">
          @if (embedContext() !== 'magazineEditionOverview') {
            @if (embedContext() !== 'selectieAndEssentie') {
              <!-- Article type -->
              <dhp-article-type-badge [article]="article" />
            }
            @if (embedContext() !== 'authorDetails') {
              <dhp-article-meta-data
                [article]="article"
                [isSelectionAndEssence]="
                  embedContext() === 'selectieAndEssentie'
                "
              />
            }
          }
        </div>
        <!-- Magazine section with 3 and 4th columns, shown sometimes below the title -->
        @if (
          article.magazine &&
          (embedContext() === 'search' || embedContext() === 'authorDetails')
        ) {
          @if (article.magazine.abbreviation || article.magazine.title) {
            <div class="subcolumn-magazine">
              @if (article.magazine.id && article.magazine.slug) {
                <a
                  [routerLink]="[
                    '/magazines/detail',
                    article.magazine.id,
                    article.magazine.slug,
                  ]"
                  (click)="$event.stopPropagation()"
                >
                  {{ article.magazine.abbreviation ?? article.magazine.title }}
                </a>
              }
              @if (
                !(article.magazine.id && article.magazine.slug) &&
                (article.magazine.abbreviation || article.magazine.title)
              ) {
                {{ article.magazine.abbreviation ?? article.magazine.title }}
              }
            </div>
          }
        }
        <!-- Edition section - only show if there's content -->
        @if (
          article.magazine &&
          article.magazine.slug &&
          (embedContext() === 'search' || embedContext() === 'authorDetails')
        ) {
          <!-- Edition information -->
          <div class="subcolumn-edition">
            @if (article.edition; as edition) {
              @if (
                article.magazine.id &&
                article.magazine.slug &&
                edition.id &&
                edition.year &&
                edition.edition_version
              ) {
                <a
                  [routerLink]="[
                    '/magazines/detail',
                    article.magazine.id,
                    article.magazine.slug,
                    'edition',
                    edition.id,
                  ]"
                  (click)="$event.stopPropagation()"
                >
                  {{
                    'common.editionShort'
                      | translate
                        : {
                            year: edition.year,
                            edition: edition.edition_version,
                          }
                  }}
                </a>
              }
              @if (
                !(article.magazine.id && article.magazine.slug) &&
                edition.id &&
                edition.year &&
                edition.edition_version
              ) {
                {{
                  'common.editionShort'
                    | translate
                      : {
                          year: edition.year,
                          edition: edition.edition_version,
                        }
                }}
              }
            }
          </div>
        }
      </div>
      <!-- Link -->
      <div class="column-icon">
        <img
          ngSrc="assets/icons/diagonal_arrow_icon.svg"
          alt=""
          height="14"
          width="14"
        />
      </div>
    </div>
  }
}

<dhp-manual-dialog [manual]="selectedArticleManual" />
